"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("./models");
var defaults_1 = require("../comparison/defaults");
exports.defaultThresholdLineStyle = function () {
    return {
        hidden: false,
        interactive: true,
        lineStyle: models_1.LineStyle.SOLID,
        deltaLabel: models_1.DeltaLabelStyle.HISTORICAL_DELTA,
        lineLabel: models_1.LineLabelStyle.NONE,
    };
};
exports.defaultThresholdFeature = function () {
    return {
        lines: [
            {
                measure: { column: defaults_1.COMPARISON_MEASURE_COLUMN_NAME },
                timestamp: { column: defaults_1.COMPARISON_TIMESTAMP_COLUMN_NAME },
                style: __assign(__assign({}, exports.defaultThresholdLineStyle()), { hidden: true }),
            },
        ],
    };
};
//# sourceMappingURL=defaults.js.map